// extracted by mini-css-extract-plugin
export default {"root":"Dots_root__fO0-O","dotWrapper":"Dots_dotWrapper__RytvC","dot":"Dots_dot__C-qSt","dotEmpty":"Dots_dotEmpty__nLnTK"};